import React from 'react'
import { getPriceVariation } from '../../../../common/utils/formatString'

export default class ItemSupportUpgrade extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExtendedSupportSelected: false,
      isUpdatingSupport: false
    }
    this.onExtendedSupportSelectChange = this.onExtendedSupportSelectChange.bind(
      this
    )
  }

  onExtendedSupportSelectChange() {
    const { editCartEntry, cartEntry, updateMatrixSupport } = this.props
    this.setState(
      {
        isExtendedSupportSelected: !this.state.isExtendedSupportSelected,
        isUpdatingSupport: true
      },
      () => {
        const updatedSupportType = this.state.isExtendedSupportSelected
          ? 'bundle_12month'
          : 'bundle_6month'
        editCartEntry(cartEntry.id, {
          ...cartEntry,
          support_key: updatedSupportType
        })
          .then(() => {
            this.setState(
              {
                isUpdatingSupport: false
              },
              () => {
                updateMatrixSupport(updatedSupportType)
              }
            )
          })
          .catch(() => {
            this.setState({
              isUpdatingSupport: false
            })
          })
      }
    )
  }

  render() {
    const { selectedMatrixLicense, itemMatrix } = this.props
    const { isExtendedSupportSelected, isUpdatingSupport } = this.state

    const selectedLicenseSupport = itemMatrix[selectedMatrixLicense].support

    const bundle12MonthPrice = selectedLicenseSupport['bundle_12month'].price
    const bundle6MonthPrice = selectedLicenseSupport['bundle_6month'].price
    const priceVariation = getPriceVariation(
      bundle6MonthPrice,
      bundle12MonthPrice
    )
    return (
      <div className="fds-c-modal__section">
        <div className="cart-modal__item-support">
          <label htmlFor="support">
            <input
              className="fds-c-form-checkbox fds-u-mr1"
              type="checkbox"
              name="support"
              disabled={isUpdatingSupport}
              checked={isExtendedSupportSelected}
              onChange={this.onExtendedSupportSelectChange}
            />
            <strong>Extend support to 12 months. {priceVariation}</strong>
          </label>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/modals/cart/itemSupportUpgrade.js